var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 9.20509C14.3208 11.5932 11.8445 13.5695 9.00055 15C6.15806 13.5689 3.68298 11.5927 1.74287 9.20509C-0.810378 6.09424 -0.686665 1.22247 2.96967 0.169707C7.01431 -0.993701 9.00055 4.59572 9.00055 4.59572C9.00055 4.59572 11.0177 -1.03796 15.0349 0.169707C18.6775 1.2604 18.8149 6.09424 16.2617 9.20509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2827e14521f76daf79c9cc2c6797cfa5.svg";
export { ForwardRef as ReactComponent };